import { loginSucceeded } from 'authentication/Login/ducks/authentication'
import apiAsync from 'infrastructure/shared/api/api-async'
import { ErrorMessage } from 'infrastructure/shared/types'
import jwtDecode from 'jwt-decode'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'

// https://github.com/auth0/jwt-decode/blob/master/index.d.ts
interface JwtHeader {
  typ?: string
  alg?: string
  kid?: string
}

const useToken = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token') || ''

  useEffect(() => {
    const validateAndSaveToken = () => {
      if (!token) return
      try {
        const decodedHeader = jwtDecode<JwtHeader>(token, { header: true })
        if (decodedHeader?.typ !== 'JWT' || decodedHeader?.alg !== 'HS256') {
          throw new Error('Invalid token')
        }

        apiAsync.setAuthToken(token)

        const decoded = jwtDecode<{ email: string; expiration_date: number }>(
          token
        )
        dispatch(
          loginSucceeded(decoded.email, {
            token,
            expiration_date: decoded.expiration_date
          })
        )

        // Remove token from URL
        searchParams.delete('token')

        // navigate para a url atual mas sem o token
        navigate(`${window.location.pathname}?${searchParams.toString()}`, {
          replace: true
        })
      } catch (error) {
        const err = error as ErrorMessage
        console.error(err.message)
      }
    }
    validateAndSaveToken()
  }, [dispatch, searchParams, token, navigate])

  return token
}

export default useToken
